/**
 * PageHeaderSkeleton Component
 * 
 * Skeleton loading state for normalized page headers.
 * Matches TYPOGRAPHY.headerGreeting + TYPOGRAPHY.pageDescription sizing.
 */

import { cn } from "@/lib/utils";
import { Skeleton } from "@/components/ui/skeleton";
import { LAYOUTS, SPACING, SKELETONS } from "@/design-system";

interface PageHeaderSkeletonProps {
  className?: string;
  /** Show description skeleton */
  showDescription?: boolean;
  /** Show action button placeholder */
  showAction?: boolean;
}

export function PageHeaderSkeleton({ 
  className,
  showDescription = true,
  showAction = false,
}: PageHeaderSkeletonProps) {
  return (
    <div className={cn(LAYOUTS.headerWrapper, SPACING.stackLg, className)}>
      <div className={LAYOUTS.headerWithAction}>
        <div className={LAYOUTS.headerContent}>
          <Skeleton className={SKELETONS.elements.header.title} />
          {showDescription && (
            <Skeleton className={cn(SKELETONS.elements.header.description, "mt-1")} />
          )}
        </div>
        {showAction && (
          <Skeleton className={SKELETONS.elements.header.action} />
        )}
      </div>
    </div>
  );
}
